import { DCUIContent, DCUITheme } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { DCUICaptureStepTypes } from "@enums/dcui-capture-step-types";
import { DCUIThemingStep } from "@idw-types/common/dcui/dcui-theming-step";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ActiveAcuantPropertyFlags } from "@idw-types/common/active-acuant-property-flags";
import { DCUIThemingCaptureStepValidationErrors, DCUIThemingValidationErrors } from "@idw-types/common/validation/common/dcui-theming-validation-errors";
import { getDCUIThemingThemeValidationErrors } from "./dcui-theming-theme-validation-util";
import { getDCUIThemingStartPageValidationErrors } from "./dcui-theming-start-page-validation-util";
import { getDCUIThemingCaptureCompleteValidationErrors } from "./dcui-theming-capture-complete-validation-util";
import { getDCUIThemingErrorPageValidationErrors } from "./dcui-theming-error-page-validation-util";
import { getDCUIThemingCaptureStepValidationErrors } from "./dcui-theming-capture-step-validation-util";
import { getDCUIThemingTextContentValidationErrors } from "./dcui-theming-text-content-validation-util";


export const getDCUIThemingValidationErrors = (
    isUsingDCUIVersion2: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    documentCaptureSteps: Array<DCUIThemingStep>,
    activeAcuantProperties: ActiveAcuantPropertyFlags,
    dcuiContent: DCUIContent,
    dcuiTheme: DCUITheme,
): DCUIThemingValidationErrors => {
    const themeValidationErrors = getDCUIThemingThemeValidationErrors(
        isUsingDCUIVersion2,
        hasDisplayableDocumentCaptureAttributes,
        dcuiContent,
        dcuiTheme
    );
    const startPageValidationErrors = getDCUIThemingStartPageValidationErrors(
        isUsingDCUIVersion2,
        hasDisplayableDocumentCaptureAttributes,
        documentCaptureSteps,
        dcuiContent
    );
    const defaultCaptureStepValidationErrors: DCUIThemingCaptureStepValidationErrors = {
        count: 0,
        tabTitle: null,
        captureButtonLabelError: null,
        customMediaURLError: null,
        instructionsError: null,
        screenOrientationPreviewTextError: null,
        titleError: null
    };
    const allCaptureStepValidationErrors = {
        [DCUICaptureStepTypes.FACE]: { ...defaultCaptureStepValidationErrors },
        [DCUICaptureStepTypes.DRIVER_LICENSE_FRONT]: { ...defaultCaptureStepValidationErrors },
        [DCUICaptureStepTypes.DRIVER_LICENSE_BACK]: { ...defaultCaptureStepValidationErrors },
        [DCUICaptureStepTypes.PASSPORT]: { ...defaultCaptureStepValidationErrors },
        [DCUICaptureStepTypes.ID_CARD_FRONT]: { ...defaultCaptureStepValidationErrors },
        [DCUICaptureStepTypes.ID_CARD_BACK]: { ...defaultCaptureStepValidationErrors }
    };

    documentCaptureSteps.forEach(dcs => {
        allCaptureStepValidationErrors[dcs.stepType] = getDCUIThemingCaptureStepValidationErrors(
            dcs,
            isUsingDCUIVersion2,
            hasDisplayableDocumentCaptureAttributes,
            dcuiContent
        );
    });

    const captureCompleteValidationErrors = getDCUIThemingCaptureCompleteValidationErrors(
        isUsingDCUIVersion2,
        hasDisplayableDocumentCaptureAttributes,
        dcuiContent
    );
    const errorPageValidationErrors = getDCUIThemingErrorPageValidationErrors(
        isUsingDCUIVersion2,
        hasDisplayableDocumentCaptureAttributes,
        dcuiContent
    );

    const textContentValidationErrors = getDCUIThemingTextContentValidationErrors(
        isUsingDCUIVersion2,
        hasDisplayableDocumentCaptureAttributes,
        activeAcuantProperties,
        dcuiContent
    );

    const allCaptureStepValidationErrorsCount = Object.values(allCaptureStepValidationErrors).map(value => value.count).reduce((a, b) => a + b, 0);

    const count = themeValidationErrors.count
        + startPageValidationErrors.count
        + allCaptureStepValidationErrorsCount
        + captureCompleteValidationErrors.count
        + errorPageValidationErrors.count
        + textContentValidationErrors.count;

    return {
        theme: themeValidationErrors,
        startPage: startPageValidationErrors,
        ...allCaptureStepValidationErrors,
        captureComplete: captureCompleteValidationErrors,
        errorPage: errorPageValidationErrors,
        textContent: textContentValidationErrors,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.dcuiTheming.tabName}
            errorCount={count}
        />
    }
};
